module.exports = __webpack_public_path__ + "static/media/hand-shake.9cc37166.svg";